export default class Place
{
  constructor(name, notes, photoPath) 
  {
    this.name = name;
    this.notes = notes;
    this.photoPath = photoPath;
  }    

  isValid()
  {
    return this.name;
  }
}